import { MOBILE_WEB_URL } from 'common/constants'
import isMobile from 'is-mobile'
import { GetServerSideProps } from 'next'
import BusinessCollectionLogo from 'services/Services/assets/svg/koleksi-belanja-grosir-logo.svg'
import Layout from 'services/Services/screens/Details'

import data from './data.json'

export const getServerSideProps: GetServerSideProps = async ({
  req,
}) => {
  const userAgent = req.headers['user-agent']
  if (isMobile({ ua: userAgent })) {
    return {
      redirect: {
        destination: `${MOBILE_WEB_URL}/services/business-collection`,
        permanent: false,
      },
    }
  }

  return {
    props: {},
  }
}

function BusinessCollection(): JSX.Element {
  return <Layout data={data} logo={<BusinessCollectionLogo />} />
}

export default BusinessCollection
